export function setTheme (color) {
  const theme = app.utils.colorThemeCSSProperties(color);
  document.documentElement.style.setProperty('--v-color-cta', theme["--f7-theme-color-shade"]);
  document.documentElement.style.setProperty('--f7-button-fill-hover-bg-color', theme["--f7-theme-color-tint"]);
  document.documentElement.style.setProperty('--f7-button-fill-pressed-bg-color',color);
  document.getElementById("metaThemeLight").setAttribute("content", theme["--f7-theme-color-tint"]);
  document.getElementById("metaThemeDark").setAttribute("content", theme["--f7-theme-color-shade"]);
}